var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-section',{staticClass:"voter-info__page-section",attrs:{"id":"vote-by-mail","title":_vm.$t('cac.app.vote_by_mail')}},[_c('p',{staticClass:"vote-by-mail-info",domProps:{"innerHTML":_vm._s(_vm.voteByMailContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }